import { render } from "./AboutComponent.vue?vue&type=template&id=4b01e6a6&ts=true"
import script from "./AboutComponent.vue?vue&type=script&lang=ts"
export * from "./AboutComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__